import { enumeration } from '@dazn/peng-html5-tools-utils';
var TargetProfileName = enumeration([
    'CHROMECAST',
    'EXOPLAYER_ANDROIDTV',
    'FALLBACK',
    'FREEBOX_REVOLUTION',
    'FRIDGE',
    'MAGENTATV_LEGACY',
    'MOBILE',
    'PS4_WEBMAF',
    'SAFARI',
    'MOBILE_SAFARI',
    'SKY_LEGACY',
    'TIZEN_LEGACY',
    'TV',
    'WEB',
    'WEB_DASHJS',
    'WEBOS_LEGACY',
    'SAGEMCOM',
]);
export { TargetProfileName };
//# sourceMappingURL=TargetProfileName.js.map